module.exports = __webpack_public_path__ + "img/DE00233.4fc73f8f.png";